export { PersistenceService } from './services/persistence.service';
export { AbstractCachedService } from './abstracts/persistence.cached_service';
export { StorageType } from './constants/persistence.storage_type';
export { PersistenceModule } from './modules/persistence.module';
//# sourceMappingURL=angular-persistence.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/angular-persistence/src/angular-persistence.js
// module id = 858
// module chunks = 3